function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { throw: 1, return: 2, break: 3, continue: 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, catch: function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { get, map, isEmpty } from 'lodash';
import moment from 'moment';
import fspUtils from '@unite-us/client-utils/dist/utils/feeSchedulePrograms';
import { isUnlistedProgram, referralIsOON, referralIsGrouped } from '../pages/builder/utils';
import { useCreateRecord, useUpdateRecord } from '../api/ApiHooks';
import { CALLBACKS, coreApi } from '../api/config';
import { useAppCreateReferralContext } from '../context/AppCreateReferralProvider';
import { useFeatureFlag } from '../utils/useFeatureFlag';
import { formatShortDate2FromTimestamp } from '../components/service_authorization/formatShortDate';
var validateRequiredValues = function validateRequiredValues(type, values) {
  var requiredFields = [];
  if (type === 'case') {
    requiredFields = ['description', 'service', 'provider', 'network', 'person'];
  } else if (type === 'note') {
    requiredFields = ['subjectType', 'subject', 'visibility', 'text'];
  } else if (type === 'referral') {
    requiredFields = ['case', 'receiving_program', 'receiving_provider', 'receiving_network', 'sending_provider', 'sending_network'];
  }
  return requiredFields.filter(function (field) {
    return !values[field];
  });
};
export default function useCreateReferrals() {
  var _useAppCreateReferral = useAppCreateReferralContext(),
    _useAppCreateReferral2 = _useAppCreateReferral.state,
    currentEmployee = _useAppCreateReferral2.currentEmployee,
    formResponses = _useAppCreateReferral2.formResponses,
    person = _useAppCreateReferral2.person,
    referrals = _useAppCreateReferral2.referrals,
    formSubmissionId = _useAppCreateReferral2.formSubmissionId,
    assistanceRequestId = _useAppCreateReferral2.assistanceRequestId,
    screeningId = _useAppCreateReferral2.screeningId;
  var crtb1239AdaptDraftReferralFlow = useFeatureFlag('crtb1239AdaptDraftReferralFlow', false);
  var hint542SupersetUnlistedPrograms = useFeatureFlag('hint542SupersetUnlistedPrograms', false);
  var pays5590RefactorInsuranceFilters = useFeatureFlag('pays5590RefactorInsuranceFilters', false);
  var showOpenedDate = useFeatureFlag('crtb824AddOpenCloseDateOffPlatformCase', false);
  var _useCreateRecord = useCreateRecord('referral'),
    createReferral = _useCreateRecord.createRecord;
  var _useCreateRecord2 = useCreateRecord('case'),
    createCase = _useCreateRecord2.createRecord;
  var _useCreateRecord3 = useCreateRecord('service_authorization'),
    createServiceAuthorization = _useCreateRecord3.createRecord;
  var _useCreateRecord4 = useCreateRecord('form_submission'),
    createFormSubmission = _useCreateRecord4.createRecord;
  var _useCreateRecord5 = useCreateRecord('note'),
    createNote = _useCreateRecord5.createRecord;
  var _useUpdateRecord = useUpdateRecord('referral'),
    updateReferral = _useUpdateRecord.updateRecord;
  var _useUpdateRecord2 = useUpdateRecord('case'),
    updateCase = _useUpdateRecord2.updateRecord;
  var _useUpdateRecord3 = useUpdateRecord('service_authorization'),
    updateServiceAuthorization = _useUpdateRecord3.updateRecord;
  var createErrorMessage = function createErrorMessage(error) {
    return error.response.data.errors.map(function (error) {
      return error.title;
    }).join(', ');
  };
  var uploadDocuments = function uploadDocuments(referral, caseToUploadDoc) {
    var attachableDocuments = get(referral, 'attachableDocuments', []);
    var filteredDocuments = attachableDocuments.filter(function (doc) {
      return doc.attached === true;
    });
    var attachedDocuments = filteredDocuments.map(function (ad) {
      return {
        title: ad.document.title,
        id: ad.document.id
      };
    });
    if (!isEmpty(attachedDocuments)) {
      var attachDocumentsToResource = function attachDocumentsToResource() {
        return coreApi.setRelationship('case', caseToUploadDoc.id, {
          relationshipModel: 'file_upload',
          value: attachedDocuments.map(function (a) {
            return a.id;
          })
        });
      };
      var uploadPromises = !isEmpty(attachedDocuments) && attachDocumentsToResource();
      Promise.all([uploadPromises]);
    }
    var uploadedDocuments = get(referral, 'attachments', []);
    if (!isEmpty(uploadedDocuments)) {
      var uploadDocumentsToResource = function uploadDocumentsToResource() {
        return uploadedDocuments.map(function (d) {
          return coreApi.uploadFile('case', caseToUploadDoc.id, d.file);
        });
      };
      var _uploadPromises = uploadDocumentsToResource();
      Promise.all(_toConsumableArray(_uploadPromises || []));
    }
  };
  var submitAssessments = function submitAssessments(_ref) {
    var cases = _ref.cases,
      latestResponses = _ref.latestResponses;
    var promises = [];
    map(cases, function (serviceCase) {
      map(latestResponses || formResponses, function (assessment) {
        var _assessment$form;
        if (!isEmpty(assessment) && (_assessment$form = assessment.form) !== null && _assessment$form !== void 0 && (_assessment$form = _assessment$form.service_type_ids) !== null && _assessment$form !== void 0 && _assessment$form.includes(serviceCase.service.id)) {
          promises.push(createFormSubmission({
            context: serviceCase.id,
            contextType: 'case',
            form: assessment.form.id,
            provider: serviceCase.provider.id,
            responses: assessment.responses,
            submitter: currentEmployee.id
          }));
        }
      });
    });
    return Promise.all(promises).then(function (responses) {
      return responses;
    }).catch(function (err) {
      CALLBACKS.notify.error("Error submitting Assessments");
      throw err;
    });
  };
  var createReferrals = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var referrals, person, draft, result, groupedReferrals, _loop, i;
      return _regeneratorRuntime().wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            referrals = _ref2.referrals, person = _ref2.person, draft = _ref2.draft;
            result = {
              referrals: [],
              cases: [],
              shippingDetail: []
            };
            groupedReferrals = referrals.some(function (r) {
              return get(r, 'programs', []).length > 1;
            });
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(i) {
              var _referrals$i$case, resultDraft, item, referral, referredToPrograms, isGrouped, isOON, createdCaseOrExistingAR, authorizationCreated, j, programData, _referral$primaryWork, caseValues, missingCaseValues, caseResponse, arCase, payload, feeScheduleProgram, _referral$paymentAuth, _referral$paymentAuth2, _responseInsurances$d, serviceStart, requestedStartDate, serviceEnd, requestedEndDate, amountRequested, icd10Codes, queryInsuranceParams, responseInsurances, insurances, state, createNoteForUnlistedProgramValues, missingNoteValues, noteReferral, _item, referralValues, missingReferralValues, responseReferral, _item2;
              return _regeneratorRuntime().wrap(function _loop$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    result.shippingDetail.push({
                      index: i,
                      sent: false,
                      error: null
                    });
                    _context.prev = 1;
                    if (!(crtb1239AdaptDraftReferralFlow && referrals[i].state === "draft")) {
                      _context.next = 19;
                      break;
                    }
                    resultDraft = undefined;
                    if (!isEmpty((_referrals$i$case = referrals[i].case) === null || _referrals$i$case === void 0 ? void 0 : _referrals$i$case.service_authorization)) {
                      _context.next = 10;
                      break;
                    }
                    _context.next = 7;
                    return updateDraftReferralCrtb1239(referrals[i]);
                  case 7:
                    resultDraft = _context.sent;
                    _context.next = 13;
                    break;
                  case 10:
                    _context.next = 12;
                    return updateDraftReferral(referrals[i], draft);
                  case 12:
                    resultDraft = _context.sent;
                  case 13:
                    item = result.shippingDetail.find(function (item) {
                      return item.index === i;
                    });
                    if (item) item.sent = true;
                    result.cases.push(resultDraft.cases[0]);
                    result.referrals.push(resultDraft.referrals[0]);
                    _context.next = 119;
                    break;
                  case 19:
                    referral = referrals[i];
                    referredToPrograms = get(referral, 'programs', []);
                    isGrouped = referralIsGrouped(referral);
                    isOON = referralIsOON(referral);
                    createdCaseOrExistingAR = null;
                    authorizationCreated = false;
                    j = 0;
                  case 26:
                    if (!(j < referredToPrograms.length)) {
                      _context.next = 119;
                      break;
                    }
                    programData = referredToPrograms[j];
                    if (!(groupedReferrals && !createdCaseOrExistingAR || !groupedReferrals)) {
                      _context.next = 75;
                      break;
                    }
                    caseValues = _objectSpread(_objectSpread(_objectSpread({
                      description: referral.description,
                      state: referralIsOON(referral) ? 'off_platform' : 'draft',
                      person: person.id,
                      provider: referral.sendingProvider.id,
                      network: referral.network.id,
                      service: referral.service.id
                    }, (_referral$primaryWork = referral.primaryWorker) !== null && _referral$primaryWork !== void 0 && _referral$primaryWork.id ? {
                      primary_worker: referral.primaryWorker.id
                    } : null), formSubmissionId ? {
                      originating_form_submission: formSubmissionId
                    } : null), screeningId ? {
                      screening2_id: screeningId
                    } : null);
                    missingCaseValues = validateRequiredValues('case', caseValues);
                    if (!missingCaseValues.length) {
                      _context.next = 33;
                      break;
                    }
                    throw new Error("The following fields for the case are required: ".concat(missingCaseValues.join(', ')));
                  case 33:
                    if (showOpenedDate && isOON) {
                      caseValues = _objectSpread(_objectSpread({}, caseValues), {}, {
                        opened_date: formatShortDate2FromTimestamp(referral.opened_date)
                      });
                    }
                    _context.prev = 34;
                    caseResponse = void 0;
                    if (!(assistanceRequestId && i === 0)) {
                      _context.next = 47;
                      break;
                    }
                    arCase = get(assistanceRequestId, 'case', null);
                    payload = {
                      description: referral.description,
                      network: referral.network.id
                    };
                    if (referral.service.id && get(arCase, 'service.id') !== referral.service.id) {
                      payload = _objectSpread(_objectSpread({}, payload), {}, {
                        service: referral.service.id
                      });
                    }
                    if (isOON) {
                      payload = _objectSpread(_objectSpread({}, payload), {}, {
                        primary_worker: referral.primaryWorker.id,
                        state: 'off_platform'
                      });
                    }
                    if (showOpenedDate && isOON) {
                      payload = _objectSpread(_objectSpread({}, payload), {}, {
                        opened_date: formatShortDate2FromTimestamp(referral.opened_date)
                      });
                    }
                    _context.next = 44;
                    return updateCase(arCase.id, payload);
                  case 44:
                    caseResponse = _context.sent;
                    _context.next = 50;
                    break;
                  case 47:
                    _context.next = 49;
                    return createCase(caseValues);
                  case 49:
                    caseResponse = _context.sent;
                  case 50:
                    createdCaseOrExistingAR = get(caseResponse, 'data.data', {});
                    feeScheduleProgram = referral.programs[0].fee_schedule_program;
                    if (!(feeScheduleProgram !== null && feeScheduleProgram !== void 0 && feeScheduleProgram.authorization_required)) {
                      _context.next = 68;
                      break;
                    }
                    serviceStart = referral === null || referral === void 0 || (_referral$paymentAuth = referral.paymentAuthForm) === null || _referral$paymentAuth === void 0 ? void 0 : _referral$paymentAuth.service_start;
                    requestedStartDate = serviceStart && moment.unix(serviceStart).toISOString();
                    serviceEnd = referral === null || referral === void 0 || (_referral$paymentAuth2 = referral.paymentAuthForm) === null || _referral$paymentAuth2 === void 0 ? void 0 : _referral$paymentAuth2.service_end;
                    requestedEndDate = serviceEnd && moment.unix(serviceEnd).toISOString();
                    if (pays5590RefactorInsuranceFilters) {
                      requestedStartDate = serviceStart && moment(requestedStartDate).add(1, 'day').toISOString();
                      requestedEndDate = serviceEnd && moment(requestedEndDate).subtract(1, 'day').toISOString();
                    }
                    amountRequested = referral.paymentAuthForm.amount_requested;
                    icd10Codes = referral.paymentAuthForm.icd10_code.id ? [referral.paymentAuthForm.icd10_code.id] : [];
                    queryInsuranceParams = {
                      person: person.id,
                      state: 'active',
                      enrolled_before: requestedStartDate,
                      expired_after: requestedEndDate,
                      'plan.fee_schedules': feeScheduleProgram.fee_schedule.id,
                      sort: '-enrolled_at'
                    };
                    _context.next = 63;
                    return coreApi.query('insurance', queryInsuranceParams);
                  case 63:
                    responseInsurances = _context.sent;
                    insurances = responseInsurances === null || responseInsurances === void 0 || (_responseInsurances$d = responseInsurances.data) === null || _responseInsurances$d === void 0 ? void 0 : _responseInsurances$d.data;
                    _context.next = 67;
                    return createServiceAuthorization(_objectSpread(_objectSpread({
                      state: draft ? 'draft' : 'requested',
                      requested_starts_at: requestedStartDate,
                      requested_ends_at: requestedEndDate
                    }, fspUtils.isCostPaymentType(feeScheduleProgram.payment_type) ? {
                      requested_cents: amountRequested
                    } : {
                      requested_unit_amount: parseInt(amountRequested)
                    }), {}, {
                      case: createdCaseOrExistingAR.id,
                      fee_schedule_program: feeScheduleProgram.id,
                      requester: currentEmployee.id,
                      insurance: insurances[0].id,
                      person: person.id,
                      clinical_modifications: icd10Codes
                    }));
                  case 67:
                    authorizationCreated = true;
                  case 68:
                    result.cases.push(createdCaseOrExistingAR);
                    _context.next = 75;
                    break;
                  case 71:
                    _context.prev = 71;
                    _context.t0 = _context["catch"](34);
                    result.shippingDetail[i].error = "Error creating the Case: ".concat(createErrorMessage(_context.t0));
                    return _context.abrupt("continue", 116);
                  case 75:
                    uploadDocuments(referral, createdCaseOrExistingAR);
                    state = void 0;
                    if (draft) {
                      state = 'draft';
                    } else if (referralIsOON(referral)) {
                      state = 'off_platform';
                    } else if (authorizationCreated) {
                      state = 'pending_authorization';
                    } else {
                      state = 'sent';
                    }
                    if (!(hint542SupersetUnlistedPrograms && isUnlistedProgram(programData))) {
                      _context.next = 98;
                      break;
                    }
                    createNoteForUnlistedProgramValues = {
                      subjectType: 'case',
                      subject: createdCaseOrExistingAR.id,
                      employee: currentEmployee.id,
                      visibility: 'public',
                      category: 'external_provider',
                      text: "Referred off platform to ".concat(programData.name)
                    };
                    missingNoteValues = validateRequiredValues('note', createNoteForUnlistedProgramValues);
                    if (!missingNoteValues.length) {
                      _context.next = 84;
                      break;
                    }
                    result.shippingDetail[i].error = "The following fields for the unlisted program are required: ".concat(missingNoteValues.join(', '));
                    return _context.abrupt("continue", 116);
                  case 84:
                    _context.prev = 84;
                    createNote(createNoteForUnlistedProgramValues);
                    noteReferral = {
                      index: i,
                      sent: true
                    };
                    result.referrals.push(noteReferral);
                    _item = result.shippingDetail.find(function (item) {
                      return item.index === i;
                    });
                    if (_item) _item.sent = true;
                    _context.next = 96;
                    break;
                  case 92:
                    _context.prev = 92;
                    _context.t1 = _context["catch"](84);
                    result.shippingDetail[i].error = "Error creating the note on the case for the unlisted program";
                    return _context.abrupt("continue", 116);
                  case 96:
                    _context.next = 116;
                    break;
                  case 98:
                    referralValues = {
                      state: state,
                      case: createdCaseOrExistingAR.id,
                      is_grouped: isGrouped,
                      receiving_program: programData.id,
                      receiving_provider: programData.provider.id,
                      receiving_network: referral.network.id,
                      sending_provider: referral.sendingProvider.id,
                      sending_network: referral.network.id
                    };
                    missingReferralValues = validateRequiredValues('referral', referralValues);
                    if (!missingReferralValues.length) {
                      _context.next = 103;
                      break;
                    }
                    result.shippingDetail[i].error = "The following fields for the referral are required: ".concat(missingReferralValues.join(', '));
                    return _context.abrupt("continue", 116);
                  case 103:
                    _context.prev = 103;
                    _context.next = 106;
                    return createReferral(referralValues);
                  case 106:
                    responseReferral = _context.sent;
                    result.referrals.push(responseReferral.data.data);
                    _item2 = result.shippingDetail.find(function (item) {
                      return item.index === i;
                    });
                    if (_item2) _item2.sent = true;
                    _context.next = 116;
                    break;
                  case 112:
                    _context.prev = 112;
                    _context.t2 = _context["catch"](103);
                    result.shippingDetail[i].error = "Error creating the Referral: ".concat(createErrorMessage(_context.t2));
                    return _context.abrupt("continue", 116);
                  case 116:
                    j += 1;
                    _context.next = 26;
                    break;
                  case 119:
                    _context.next = 124;
                    break;
                  case 121:
                    _context.prev = 121;
                    _context.t3 = _context["catch"](1);
                    result.shippingDetail[i].error = "Unexpected error: ".concat(_context.t3.message);
                  case 124:
                  case "end":
                    return _context.stop();
                }
              }, _loop, null, [[1, 121], [34, 71], [84, 92], [103, 112]]);
            });
            i = 0;
          case 5:
            if (!(i < referrals.length)) {
              _context2.next = 10;
              break;
            }
            return _context2.delegateYield(_loop(i), "t0", 7);
          case 7:
            i += 1;
            _context2.next = 5;
            break;
          case 10:
            return _context2.abrupt("return", result);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee);
    }));
    return function createReferrals(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var updateDraftReferralCrtb1239 = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(referral) {
      var _caseResponse$data, _caseResponse$data2, _yield$Promise$all, _yield$Promise$all2, caseRequestResponse, referralsRequestResponse, oldCase, oldReferrals, serviceTypeChanged, descriptionChanged, serviceCasePayload, caseResponse, referralsToDelete, formRecipientsIds, createReferralPromises, referralResponse;
      return _regeneratorRuntime().wrap(function _callee2$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return Promise.all([coreApi.findRecord('case', referral.case.id), coreApi.query('referral', {
              case: referral.case.id
            })]);
          case 3:
            _yield$Promise$all = _context3.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            caseRequestResponse = _yield$Promise$all2[0];
            referralsRequestResponse = _yield$Promise$all2[1];
            oldCase = get(caseRequestResponse, 'data.data', null);
            oldReferrals = get(referralsRequestResponse, 'data.data', null);
            serviceTypeChanged = referral.service.id !== oldCase.service_type.id;
            descriptionChanged = referral.description && referral.description !== oldCase.description;
            serviceCasePayload = _objectSpread(_objectSpread({}, serviceTypeChanged && {
              service: {
                id: referral.service.id
              }
            }), descriptionChanged && {
              description: referral.description
            });
            if (!isEmpty(serviceCasePayload)) {
              _context3.next = 16;
              break;
            }
            _context3.t0 = oldCase;
            _context3.next = 19;
            break;
          case 16:
            _context3.next = 18;
            return updateCase(referral.case.id, serviceCasePayload);
          case 18:
            _context3.t0 = _context3.sent;
          case 19:
            caseResponse = _context3.t0;
            uploadDocuments(referral, oldCase);
            referralsToDelete = [];
            oldReferrals.forEach(function (r) {
              referralsToDelete.push(coreApi.deleteRecord('referral', r.id));
            });
            if (!referralsToDelete.length) {
              _context3.next = 26;
              break;
            }
            _context3.next = 26;
            return Promise.all(referralsToDelete);
          case 26:
            formRecipientsIds = map(referral.programs, function (r) {
              return {
                provider_id: r.provider.id,
                network: referral.network,
                program_id: r.id
              };
            });
            createReferralPromises = [];
            formRecipientsIds.forEach(function (r) {
              var newReferral = createReferral({
                state: 'sent',
                case: oldCase.id,
                receiving_program: r.program_id,
                receiving_provider: r.provider_id,
                receiving_network: r.network.id,
                sending_provider: oldCase.provider.id,
                sending_network: oldCase.network.id
              });
              createReferralPromises.push(newReferral);
            });
            _context3.next = 31;
            return Promise.all(createReferralPromises);
          case 31:
            referralResponse = _context3.sent;
            return _context3.abrupt("return", {
              cases: [caseResponse !== null && caseResponse !== void 0 && (_caseResponse$data = caseResponse.data) !== null && _caseResponse$data !== void 0 && _caseResponse$data.data ? caseResponse === null || caseResponse === void 0 || (_caseResponse$data2 = caseResponse.data) === null || _caseResponse$data2 === void 0 ? void 0 : _caseResponse$data2.data : oldCase],
              referrals: [referralResponse === null || referralResponse === void 0 ? void 0 : referralResponse.data]
            });
          case 35:
            _context3.prev = 35;
            _context3.t1 = _context3["catch"](0);
            CALLBACKS.notify.error("Error updating the Draft Referral");
            throw _context3.t1;
          case 39:
          case "end":
            return _context3.stop();
        }
      }, _callee2, null, [[0, 35]]);
    }));
    return function updateDraftReferralCrtb1239(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var updateServiceAuthorizationHandler = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(referral) {
      var _referral$paymentAuth3, _referral$paymentAuth4, _responseInsurances$d2;
      var options,
        feeScheduleProgram,
        serviceStart,
        requestedStartDate,
        serviceEnd,
        requestedEndDate,
        amountRequested,
        queryInsuranceParams,
        responseInsurances,
        insurances,
        _args4 = arguments;
      return _regeneratorRuntime().wrap(function _callee3$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {
              draft: false
            };
            feeScheduleProgram = referral.programs[0].fee_schedule_program;
            serviceStart = referral === null || referral === void 0 || (_referral$paymentAuth3 = referral.paymentAuthForm) === null || _referral$paymentAuth3 === void 0 ? void 0 : _referral$paymentAuth3.service_start;
            requestedStartDate = serviceStart && moment.unix(serviceStart).toISOString();
            serviceEnd = referral === null || referral === void 0 || (_referral$paymentAuth4 = referral.paymentAuthForm) === null || _referral$paymentAuth4 === void 0 ? void 0 : _referral$paymentAuth4.service_end;
            requestedEndDate = serviceEnd && moment.unix(serviceEnd).toISOString();
            if (pays5590RefactorInsuranceFilters) {
              requestedStartDate = serviceStart && moment(requestedStartDate).add(1, 'day').toISOString();
              requestedEndDate = serviceEnd && moment(requestedEndDate).subtract(1, 'day').toISOString();
            }
            amountRequested = referral.paymentAuthForm.amount_requested;
            queryInsuranceParams = {
              person: person.id,
              state: 'active',
              enrolled_before: requestedStartDate,
              expired_after: requestedEndDate,
              'plan.fee_schedules': feeScheduleProgram.fee_schedule.id,
              sort: '-enrolled_at'
            };
            _context4.next = 11;
            return coreApi.query('insurance', queryInsuranceParams);
          case 11:
            responseInsurances = _context4.sent;
            insurances = responseInsurances === null || responseInsurances === void 0 || (_responseInsurances$d2 = responseInsurances.data) === null || _responseInsurances$d2 === void 0 ? void 0 : _responseInsurances$d2.data;
            _context4.next = 15;
            return updateServiceAuthorization(referral.case.service_authorization.id, _objectSpread(_objectSpread(_objectSpread({}, options.draft ? {} : {
              state: 'requested'
            }), {}, {
              requested_starts_at: requestedStartDate,
              requested_ends_at: requestedEndDate
            }, fspUtils.isCostPaymentType(feeScheduleProgram.payment_type) ? {
              requested_cents: amountRequested
            } : {
              requested_unit_amount: parseInt(amountRequested)
            }), {}, {
              requester: currentEmployee.id,
              insurance: insurances[0].id,
              person: person.id
            }));
          case 15:
          case "end":
            return _context4.stop();
        }
      }, _callee3);
    }));
    return function updateServiceAuthorizationHandler(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
  var updateDraftReferral = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(referral, draft) {
      var promises, isAuthRequired, newState, responses;
      return _regeneratorRuntime().wrap(function _callee4$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            promises = [updateCase(referral.case.id, {
              description: referral.description
            })];
            isAuthRequired = get(referral, 'programs[0].fee_schedule_program.authorization_required', false);
            if (!draft) {
              if (referralIsOON(referral)) {
                newState = 'off_platform';
              } else if (isAuthRequired) {
                newState = 'pending_authorization';
              } else {
                newState = 'sent';
              }
              promises.push(updateReferral(referral.id, {
                state: newState
              }));
            }
            if (isAuthRequired) {
              promises.push(updateServiceAuthorizationHandler(referral, {
                draft: draft
              }));
            }
            _context5.next = 7;
            return Promise.all(promises);
          case 7:
            responses = _context5.sent;
            return _context5.abrupt("return", {
              referrals: draft ? [] : [responses[1].data.data],
              cases: [responses[0].data.data]
            });
          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](0);
            CALLBACKS.notify.error("Error updating the Draft Referral");
            throw _context5.t0;
          case 15:
          case "end":
            return _context5.stop();
        }
      }, _callee4, null, [[0, 11]]);
    }));
    return function updateDraftReferral(_x4, _x5) {
      return _ref6.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _ref8,
      _ref8$draft,
      draft,
      latestResponses,
      response,
      _args6 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _ref8 = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {}, _ref8$draft = _ref8.draft, draft = _ref8$draft === void 0 ? false : _ref8$draft, latestResponses = _ref8.latestResponses;
          response = {};
          if (!crtb1239AdaptDraftReferralFlow) {
            _context6.next = 8;
            break;
          }
          _context6.next = 5;
          return createReferrals({
            referrals: referrals,
            person: person,
            draft: draft
          });
        case 5:
          response = _context6.sent;
          _context6.next = 17;
          break;
        case 8:
          if (!(referrals.length === 1 && referrals[0].id && referrals[0].state === "draft")) {
            _context6.next = 14;
            break;
          }
          _context6.next = 11;
          return updateDraftReferral(referrals[0], draft);
        case 11:
          response = _context6.sent;
          _context6.next = 17;
          break;
        case 14:
          _context6.next = 16;
          return createReferrals({
            referrals: referrals,
            person: person,
            draft: draft
          });
        case 16:
          response = _context6.sent;
        case 17:
          if (!(formResponses || latestResponses)) {
            _context6.next = 20;
            break;
          }
          _context6.next = 20;
          return submitAssessments({
            cases: response.cases,
            latestResponses: latestResponses
          });
        case 20:
          return _context6.abrupt("return", {
            cases: response.cases,
            referrals: response.referrals,
            shippingDetail: response.shippingDetail
          });
        case 21:
        case "end":
          return _context6.stop();
      }
    }, _callee5);
  }));
}
;
//# sourceMappingURL=useCreateReferrals.js.map